let url = 'v1/admin/statistics';

export const siteStatisticsEndpoints = {
  getSiteStatistics: {
    url: `${url}`,
    method: 'GET',
  },
};

